import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App.jsx';
import 'bootstrap/dist/css/bootstrap.css';
import { AppConfigProvider } from './context/AppConfigContext.jsx';
import { AppProvider } from './context/appContext.jsx';
import { ErrorProvider } from './context/errorContext.jsx';
import { SnackbarProvider } from './context/SnackbarContext.jsx';
import { TranslationProvider } from './context/TranslationContext.jsx';
import { BackendStatusProvider } from './context/backendStatus/backendStatusContext.jsx';
import { AuthProvider } from './context/AuthContext.jsx';
import { CognitoProvider } from './context/CognitoContext.jsx';
import { AppWorkflowProvider } from './context/AppWorkflowContext.jsx';
import { PollingManagerProvider } from './context/PollingManagerContext.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import ErrorFallback from './components/ErrorFallback/ErrorFallback';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <AppConfigProvider>
    <TranslationProvider>
      <SnackbarProvider>
        <ErrorProvider>
          <ErrorBoundary fallback={ErrorFallback}>
            <AppProvider>
              <BackendStatusProvider>
                <AuthProvider>
                  <CognitoProvider>
                    <AppWorkflowProvider>
                      <PollingManagerProvider>
                        <App />
                      </PollingManagerProvider>
                    </AppWorkflowProvider>
                  </CognitoProvider>
                </AuthProvider>
              </BackendStatusProvider>
            </AppProvider>
          </ErrorBoundary>
        </ErrorProvider>
      </SnackbarProvider>
    </TranslationProvider>
  </AppConfigProvider>,
);
